import './App.css';
import Eduvault from './Eduvault';

function App() {
  return (
    <div className="App">
      <Eduvault />
    </div>
  );
}

export default App;
